import { useState, useEffect, useRef } from "react";
import Dropdown from './Dropdown.js';
import { Link as RouterLink } from "react-router-dom";
import '../scss/dropdown.scss';

const MenuItems = ({ items, depthlevel, handleScroll }) => {
     

    const [dropdown, setDropdown] = useState(false);
    let ref = useRef();

    useEffect(() => {
        const handler = (event) => {
            if (dropdown && ref.current && !ref.current.contains(event.target)) {
                setDropdown(false);
            }
        };
        document.addEventListener("mousedown", handler);
        document.addEventListener("touchstart", handler);
        return () => {
            // Cleanup the event listener
            document.removeEventListener("mousedown", handler);
            document.removeEventListener("touchstart", handler);
        };
    }, [dropdown]);

    const onMouseEnter = () => {
        window.innerWidth > 960 && setDropdown(true);
    };
    const onMouseLeave = () => {
        window.innerWidth > 960 && setDropdown(false);
    };

 
    return (
        // <li
        //     className="menu-items"
        //     ref={ref}
        //     onMouseEnter={onMouseEnter}
        //     onMouseLeave={onMouseLeave}
        // >
        //     {items.submenu ? (
        //         <>
        //             <button
        //                 type="button"
        //                 aria-haspopup="menu"
        //                 aria-expanded={dropdown ? "true" : "false"}
        //                 onClick={() => setDropdown(!dropdown)}
        //             >
        //                 {depthlevel > 0 && <span className="dot-before"></span>}
        //                 {items.title}
        //                 {depthlevel > 0 && <span className="dot-after"></span>}
        //             </button>
        //             <Dropdown
        //                 depthlevel={depthlevel}
        //                 submenus={items.submenu}
        //                 dropdown={dropdown}
        //                 handleScroll={handleScroll}
        //             />
        //         </>
        //     ) : (
        //         <span 
        //             className="nav-link"
        //             onClick={() => handleScroll(items.sectionId)}
        //             style={{ cursor: "pointer",color: 'black' }}
        //         >
        //             {items.title}
        //         </span>
        //     )}
        // </li>
        <li
            className="navbar-item"
            ref={ref}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            {items.submenu 

            ? 
            (<>
                <button type="button" aria-haspopup="menu" aria-expanded={dropdown ? "true" : "false"}
                    onClick={
                        () => setDropdown((prev) => !prev)
                    }>
                    {
                        depthlevel > 0 ?
                            <span className="dot-before"></span>
                            :
                            null
                    }
                    {
                        items.title
                    } {
                        " "
                    } {
                        depthlevel > 0 ?
                            <span className="dot-after"></span>
                            :
                            null
                    }
                </button> <Dropdown depthlevel={
                    depthlevel
                } submenus={
                    items.submenu
                } dropdown={
                    dropdown
                }
                /></>
            ) 

            : 
            (
            // <RouterLink to={{ pathname: items.url, query: (items.param >= 0) ? items?.param : '',sectionId:items?.sectionId }}>{
            //         items.title
            //     }
            //     </RouterLink>
            (<span className="navbar-link" onClick={() => handleScroll(items.sectionId)} >
                {
                    items.title
                }
            </span>)
            )
            } </li>
    );
    

};

export default MenuItems;